import { parseOnboardingProfileData } from "@healthos/schemas";
import type { DistanceUnit } from "../lib/distance-units";
import { useOnboardingQuery } from "./use-onboarding-query";

export function useDistanceUnit(): DistanceUnit {
  const onboarding = useOnboardingQuery();
  return parseOnboardingProfileData(onboarding.data?.onboarding?.data).units === "us"
    ? "us"
    : "metric";
}
